{
  "terms-of-service": "Términos De Servicio",
  "read-terms-of-service": "Por favor, dedique unos minutos a leer nuestros Términos De Servicio.",
  "agree-terms-of-service": "He leído y acepto los términos y condiciones del servicio.",
  "add-license": "Agregar licencia",
  "welcome": "Bienvenido a la experiencia de Championship Title",
  "excited": "Estamos emocionados de tenerte con nosotros.",
  "thanks": "Gracias por tomarse unos minutos para configurar su perfil.",
  "go-to-profile": "Ir a mi perfil",
  "basic-information": "Información Básica",
  "error": "Error actualizando data",
  "proceed": "Proceder",
  "terms-item-one": "1. Aceptación de Términos y Descripción de la Plataforma",
  "terms-item-two": "2. No Sustituye el Asesoramiento Legal",
  "terms-item-three": "3. Responsabilidades del Usuario y Uso Aceptable",
  "terms-item-four": "4. Confidencialidad y Seguridad de Datos",
  "terms-item-five": "5. Limitaciones de Responsabilidad y Descargos",
  "terms-item-six": "6. Derechos de Propiedad Intelectual",
  "terms-item-seven": "7. Cuentas de Usuario, Autenticación y Controles de Acceso",
  "terms-item-eight": "8. Resolución de Disputas y Ley Aplicable",
  "terms-item-nine": "9. Modificaciones a los Términos de Servicio",
  "terms-item-ten": "10. Terminación del Servicio",
  "terms-item-eleven": "11. Divulgaciones Obligatorias para Servicios de Título en Texas",
  "terms-item-twelve": "12. Contacto y Soporte",
  "terms-item-thirteen": "13. Divisibilidad",
  "terms-item-fourteen": "14. Acuerdo Completo",
  "proceed-disclaimer": "Al hacer clic en \"Proceder\" o acceder a la Plataforma, usted reconoce que ha leído estos Términos de Servicio, los comprende y acepta estar sujeto a ellos."
}
